<common_article_header>

    <header class="com-article-header">
        <div class="sec-inner">
            <h2 class="com-article__ttl">
                <span class="sub com-ft-en">{state.article_title_en}</span>
                <span class="main">{state.article_title_jp}</span>
            </h2>
        </div>
    </header>

    <script>

        export default {
            state:{
                article_title_en : "",
                article_title_jp : ""
            },onMounted(props,state){

                this.state.article_title_en = props.article_title_en;
                this.state.article_title_jp = props.article_title_jp;

                this.update();

                let my = this;
                $(window).on("article-title:page_common_infos",function (event,data) {
                    my.state.article_title_en = data.article_title_en;
                    my.state.article_title_jp = data.article_title_jp;
                    my.update();
                });
            }
        }

    </script>

</common_article_header>